import {PurchaseOrderItem, SourceMode, ToSourceItem} from "../../../../api/Logistics";
import {
    Table,
    ViewOnly
} from "../../../../misc/scroller/Table";
import {api} from "../../../../api/API";
import {ProjectCol, toSourceTableName} from "../PartsToSource";
import {useMemo} from "react";
import {CheckboxSelectorCol} from "../../../project/shopdrawing/Checkbox";
import {useActionCol} from "./ActionCol";
import {getAll} from "../../routes/useGetAll";

export function Misc(props: {
    purchaseOrder?: number;
    supplier?: {
        id: number;
        name: string;
    };
    tab: string;
    sourceMode: SourceMode;
}) {
    const mfg = props.supplier?.id;
    const key = useMemo(() => {
        return props.purchaseOrder + "-" + mfg + "-" + props.tab
    }, [props.purchaseOrder, mfg, props.tab])


    const actionCol = useActionCol({
        purchaseOrder: props.purchaseOrder,
        sourceMode: props.sourceMode,
        update: (dt: Partial<PurchaseOrderItem>, input: ToSourceItem) => {
            return Object.assign({}, dt, {
                linkedMiscPrice: input.linkedMiscPrice,
                linkedProjectWorkOrderItem: input.linkedProjectWorkOrderItem,
                description: input.name,
                qty: 1,
            });
        }
    });

    return (
        <Table<ToSourceItem>
            key={key}
            name={toSourceTableName}
            columns={[
                props.purchaseOrder ? CheckboxSelectorCol({}) : null,
                ViewOnly(ProjectCol("Project", "projectName", "projectNumber", 100)),
                ViewOnly({
                    name: "Name",
                    render: dt => {
                        return dt.name;
                    },
                    width: 400,
                }),
                actionCol,
            ]}
            fetch={ctx => getAll(ctx, offset => api.logistics.listToSourceItems({
                offset,
                type: "misc",
            }))}
            fetchDeps={[]}
        />
    )
}